import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.18 14.675a1.126 1.126 0 000-1.572L10.135 10l3.046-3.103a1.126 1.126 0 000-1.572 1.077 1.077 0 00-1.542 0L7.82 9.215a1.126 1.126 0 000 1.57l3.818 3.89a1.077 1.077 0 001.543 0z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
